import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useMapsTotal } from '~workspace/states/maps'
import { setCurrentTab, useCurrentTab } from '~workspace/states/ui'
import {
  useIsWorkspaceOwner,
  useWorkspace,
  useWorkspaceLoading
} from '~workspace/states/workspace'
import { View } from './view'

const TabBar = () => {
  const dispatch = useDispatch()

  const total = useMapsTotal()
  const currentTab = useCurrentTab()
  const workspace = useWorkspace()
  const loading = useWorkspaceLoading()
  const isWorkspaceOwner = useIsWorkspaceOwner()
  const { memberCollection } = workspace

  const handleTabChange = (_, nextTab) => {
    dispatch(setCurrentTab(nextTab))
  }

  return (
    <View
      canUpdateWorkspaceSettings={isWorkspaceOwner}
      totalMaps={total}
      totalCollections={0}
      totalMembers={memberCollection?.total || 1}
      loading={loading}
      currentTab={currentTab}
      onTabChange={handleTabChange}
    />
  )
}

TabBar.propTypes = {
  currentTab: PropTypes.string,
  onTabChange: PropTypes.func
}

export { TabBar }
export default TabBar
